export default "__VITE_ASSET__D5IXWDcS__"